import React from "react";
import { Container, Card, Row, Col } from "react-bootstrap";
import NestedPageHero from "./NestedPageHero";

const CouplePage = () => {
  return (
    <div>
      <NestedPageHero title={"Couple"} />
      <Container className="my-5">
        <h1 className="text-center text-warning mb-4">Spaces for Couples</h1>
        <Row>
          <Col md={6}>
            <Card className="border-0 shadow">
              <Card.Img variant="top" src="/images/3.webp" height={300} />
              <Card.Body>
                <Card.Title>Cozy Rooms</Card.Title>
                <Card.Text>
                  Designed for comfort and privacy, ideal for couples.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6}>
            <Card className="border-0 shadow">
              <Card.Img variant="top" src="/images/2.webp" height={300} />
              <Card.Body>
                <Card.Title>Shared Amenities</Card.Title>
                <Card.Text>
                  Enjoy shared spaces like dining areas and lounges.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CouplePage;
